<template>
    <div v-show="visible">
        <div :class="['yx-overlay', overlay?`yx-overlay--black`:'']" v-if="overlay||forbidClick" @click="closeOnClick&&close()">
        </div>
        <div :class="[
        'yx-toast',
        type  ? `yx-toast--${ type }` : '',
        position ? `yx-toast--${ position }` : ''
      ]" @click="closeOnClick&&close()">
            <template v-if="!icon">
                <svg v-if="type==='success'" t="1610615905433" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1325" width="200" height="200">
                    <path d="M89.216226 575.029277c-6.501587-7.223986-10.47478-15.892769-12.641975-26.367549-1.805996-10.47478-0.722399-20.22716 3.973192-29.257143l4.695591-10.47478c5.05679-8.307584 11.558377-13.725573 19.865961-15.892769 7.946384-2.167196 15.892769-0.361199 23.477954 5.417989L323.995767 639.322751c8.307584 5.779189 17.698765 8.668783 27.812346 8.307584 10.11358-0.361199 18.782363-3.611993 26.006349-10.11358L898.302646 208.411993c7.585185-5.779189 16.253968-8.307584 26.006349-7.585185 9.752381 0.722399 18.059965 4.334392 24.922751 10.47478l-12.641975-12.641975c6.501587 7.223986 9.752381 15.17037 9.752381 24.561552 0 9.391182-3.250794 17.337566-9.752381 24.561552L376.008466 816.310406c-7.223986 7.223986-15.17037 10.47478-24.200353 10.47478-9.029982 0-16.976367-3.250794-24.200353-9.752381L89.216226 575.029277z" p-id="1326" fill="#ffffff"></path>
                </svg>
                <svg v-if="type==='fail'" t="1610616291734" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5593" width="200" height="200">
                    <path d="M512 816a36 36 0 1 1 36-36 36 36 0 0 1-36 36z m51.83-551.95L548 636a36 36 0 0 1-72 0l-15.83-371.95c-0.1-1.33-0.17-2.68-0.17-4.05a52 52 0 0 1 104 0c0 1.37-0.07 2.72-0.17 4.05z" p-id="5594" fill="#ffffff"></path>
                </svg>
                <svg v-if="type==='loading'" t="1610621616596" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1205" width="200" height="200">
                    <path d="M300.552 796.586q0 30.284-21.427 51.711t-51.711 21.427q-29.712 0-51.425-21.713t-21.713-51.425q0-30.284 21.427-51.711t51.711-21.427 51.711 21.427 21.427 51.711z m284.553 117.707q0 30.284-21.427 51.71t-51.71 21.428-51.712-21.427-21.427-51.711 21.427-51.711 51.711-21.427 51.711 21.427 21.427 51.71z m-402.26-402.26q0 30.284-21.427 51.71t-51.71 21.428-51.712-21.427-21.427-51.711 21.427-51.711 51.711-21.427 51.711 21.427 21.427 51.71zM869.66 796.586q0 29.712-21.713 51.425t-51.426 21.713q-30.283 0-51.71-21.427t-21.428-51.711 21.427-51.711 51.711-21.427 51.711 21.427 21.428 51.711zM318.837 227.48q0 37.711-26.856 64.567t-64.567 26.855-64.567-26.855-26.856-64.567 26.856-64.568 64.567-26.855 64.567 26.855 26.856 64.568z m668.528 284.553q0 30.284-21.427 51.71t-51.71 21.428-51.712-21.427-21.427-51.711 21.427-51.711 51.711-21.427 51.711 21.427 21.427 51.71z m-365.69-402.26q0 45.711-31.998 77.71t-77.71 31.997-77.71-31.998-31.997-77.71 31.998-77.709T511.968 0.066t77.709 31.997 31.997 77.71zM924.511 227.48q0 53.139-37.712 90.565t-90.28 37.426q-53.139 0-90.565-37.426t-37.426-90.565q0-52.569 37.426-90.28t90.565-37.712q52.569 0 90.28 37.712t37.712 90.28z" p-id="1206" fill="#ffffff"></path>
                </svg>
            </template>
            <template v-else>
                <img class="icon" :src="icon" />
            </template>
            <p v-if="!useHtmlStr">{{message}}</p>
            <p v-else v-html='message'></p>
        </div>
    </div>

</template>
<script>
export default {
    name: 'toast',
    data() {
        return {
            visible: false,
            message: '',
            icon: '',
            type: 'info',
            position: 'center',
            overlay: false,
            forbidClick: false,
            closeOnClick: false,
            duration: 2000,
            onClose: null,
            closed: false,
            timer: null,
        }
    },
    watch: {
        closed(newVal) {
            if (newVal) {
                this.visible = false
            }
        },
    },
    computed: {
        useHtmlStr() {
            return this.type === 'html'
        },
    },
    mounted() {
        this.startTimer()
    },
    methods: {
        startTimer() {
            if (this.duration > 0) {
                this.timer = setTimeout(() => {
                    if (!this.closed) {
                        this.close()
                    }
                }, this.duration)
            }
        },
        clearTimer() {
            clearTimeout(this.timer)
        },
        close() {
            this.closed = true
            if (typeof this.onClose === 'function') {
                this.onClose(this)
            }
        },
    },
}
</script>